/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import { useSnackbar } from 'notistack5';
import {
  // filterClient,
  // deleteClient,
  getMasterFileData,
  deleteMasterFile,
  resetMasterFileError,
  resetDeleteFileSuccess
} from 'src/redux/slices/masterfile';
import { useDispatch, useSelector } from 'react-redux';
import AlertDialog from 'src/components/common-components/AlertDialog';
import FileManagementTable from './MasterfileTable';

FileManagementList.propTypes = {
  setEditId: PropTypes.func,
  deleteId: PropTypes.array,
  setDeleteId: PropTypes.func
};
export default function FileManagementList({ setEditId, deleteId, setDeleteId }) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { deleteFileSuccess, error, isError } = useSelector((state) => state.filemanager);
  const handleDelete = (id) => {
    setDeleteId(id);
    setOpen(true);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteMasterFile(deleteId));
    setOpen(false);
  };

  useEffect(() => {
    if (deleteFileSuccess) {
      enqueueSnackbar('Files Deleted Successfully', {
        variant: 'success'
      });
      dispatch(resetDeleteFileSuccess());
      dispatch(getMasterFileData());
    } else if (isError) {
      enqueueSnackbar(error, {
        variant: 'error'
      });
      dispatch(resetMasterFileError());
      dispatch(getMasterFileData());
    }
    // else if(deleteFileSuccess)
  }, [deleteFileSuccess, isError]);

  const handleEdit = (id) => {
    setEditId(id);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title="Delete?"
          content="Are you sure you want to Delete files permanently?"
          okFunction={handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <FileManagementTable handleEdit={handleEdit} handleDelete={handleDelete} />
      </Card>
    </Container>
  );
}
